import React from 'react';
import PropTypes from 'prop-types';
// Styles
import { Wrapper, Divider } from './MovieGrid.styles';

export const LetterDivider = ({ letter, count }) => (
  <Divider id={`letter-${letter === '#' ? 'num' : letter}`}>
    <span className='letter'>{letter}</span>
    <span className='rule' />
    <span className='count'>
      {count} {count === 1 ? 'title' : 'titles'}
    </span>
  </Divider>
);

LetterDivider.propTypes = {
  letter: PropTypes.string,
  count: PropTypes.number
};

const MovieGrid = ({ children }) => <Wrapper>{children}</Wrapper>;

export default MovieGrid;
